import { Model } from "@vuex-orm/core";
import Customer from "./Customer";

export default class ContactInfo extends Model {
  static entity = "contactInfos";

  static fields() {
    return {
      createdAt: this.attr(),
      updatedAt: this.attr(),
      id: this.attr(),
      isDirty: this.boolean(false),
      customerId: this.number(0),
      type: this.attr(),
      label: this.attr(),
      detail: this.attr(),
      receiveNotification: this.boolean(true),
      customer: this.belongsTo(Customer, "customerId")
    };
  }

  static mutators() {
    return {
      createdAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      },
      updatedAt(value) {
        if (typeof value == "string") {
          value = Date.parse(value);
        }
        return value;
      }
    };
  }
}
